import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"

import { cn } from "@/lib/utils"

const CheckGlyph = () => (
  <svg
    aria-hidden
    viewBox="0 0 20 20"
    className="h-6 w-6"
    fill="none"
  >
    <rect x="0" y="0" width="20" height="20" rx="6" fill="#3B97B1" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25 9.25L8.75 11.75L13.75 6.75L15.25 8.25L8.75 14.75L5.25 11.25L6.25 10.25L6.25 9.25Z"
      fill="white"
    />
  </svg>
)

const MinusGlyph = () => (
  <svg
    aria-hidden
    viewBox="0 0 20 20"
    className="h-6 w-6"
    fill="none"
  >
    <rect x="0" y="0" width="20" height="20" rx="6" fill="#3B97B1" />
    <path d="M6 10H14" stroke="white" strokeWidth="2" strokeLinecap="round" />
  </svg>
)

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => {
  const isIndeterminate = props.checked === "indeterminate"

  return (
    <CheckboxPrimitive.Root
      ref={ref}
      data-slot="checkbox"
      className={cn(
        "peer inline-flex h-[20px] w-[20px] shrink-0 items-center justify-center rounded-[6px] border border-[#CDCDCD] bg-white transition-none outline-none data-[state=checked]:border-transparent data-[state=checked]:bg-transparent disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex h-[20px] w-[20px] items-center justify-center"
      >
        {isIndeterminate ? <MinusGlyph /> : <CheckGlyph />}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
})
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
